module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"email":"Email","permission":"Я даю согласие на хранение и обработку моих","personalData":"персональных данных","continue":"Далее"}}')
  delete Component.options._Ctor
}
